import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Box, Button } from '@material-ui/core'
import { addressFormValidation } from '../../../../utils/validationSchema'
import { FormLoader } from '../../../Loader/FormLoader'
import FormSelectField from '../../../../FormFields/FormSelectField'
import FormTextField from '../../../../FormFields/FormTextField'
import countryCodes from '../../../../configurations/country-codes'
import governates from '../../../../configurations/governates'
import cities from '../../../../configurations/cities'
import FormSearchField from '../../../../FormFields/FormSearchField'

const AddressForm = ({ address, onSubmit, cancelDialog, isForeign, isIssuer, locale, formClasses }) => {
  const [currentGovernate, setCurrentGovernate] = React.useState(null)
  const [reLoad, setReLoad] = React.useState(false)
  const addressForm = useFormik({
    initialValues: {
      country: !!isForeign ? '' : 'EG',
      governate: '',
      regionCity: '',
      street: '',
      buildingNumber: '',
      floor: '',
      room: '',
      landmark: '',
      postalCode: '',
      additionalInformation: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    validationSchema: addressFormValidation,
    onSubmit: ((values, actions) => {
      let country = countryCodes?.filter(country => country?.key?.toString() === values?.country?.toString())
      if (!!country?.length) {
        country = country[0]
      }
      onSubmit({ countryName: country[`name_${locale}`] || '', ...values })
    })
  })
  const NumberChange = (event, fieldName) => {
    const re = /^[0-9\b]+$/
    if (event.target.value === '' || re.test(event.target.value)) {
      addressForm.setFieldValue(fieldName, event.target.value)
    }
  }

  React.useEffect(() => {
    if (!!Object.keys(address || {}).length) {
      addressForm.setValues({
        country: address?.country || 'EG',
        governate: address?.governate || '',
        regionCity: address?.regionCity || '',
        street: address?.street || '',
        buildingNumber: address?.buildingNumber || '',
        floor: address?.floor || '',
        room: address?.room || '',
        landmark: address?.landmark || '',
        postalCode: address?.postalCode || '',
        additionalInformation: address?.additionalInformation || ''
      })
      setTimeout(() => { setReLoad(true); console.log("address reloaded") }, 100)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [address])

  return (
    <Box px={4} pt={1} pb={4}>
      {console.log(addressForm)}
      <form onSubmit={addressForm.handleSubmit} noValidate autoComplete="off"
        className={formClasses.formWrapper}>

        <FormSelectField name={'country'} labelKey={'Fields.label.country'}
          classes={formClasses} displayEmpty={!!isForeign}
          formActions={addressForm} required
          disabled={!!isIssuer}
          list={!!isIssuer ? countryCodes?.filter(country => country.key === 'EG') : (!!isForeign ? countryCodes?.filter(country => country.key !== 'EG') : countryCodes)}
          locale={locale} />

        {
          !!isForeign || addressForm?.values?.country !== 'EG' ?
            <FormTextField name={'governate'} labelKey={'Fields.label.governate'} classes={formClasses}
              formActions={addressForm} required />
            :
            <FormSearchField name={'governate'} labelKey={'Fields.label.governate'} classes={formClasses} load={reLoad}
              setReturnedObj={setCurrentGovernate} locale={locale} formActions={addressForm}
              list={governates} required
              filterFunction={locale === 'ar' && ({
                filterOptions: (options, state) => options.filter(option => option['name_ar']?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا')?.includes(state?.inputValue?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا')) || option['name_en']?.toLowerCase()?.includes(state?.inputValue?.toLowerCase()))
              })} />
        }

        {
          !!isForeign || addressForm?.values?.country !== 'EG' ?
            <FormTextField name={'regionCity'} labelKey={'Fields.label.regionCity'} classes={formClasses}
              formActions={addressForm} required />
            :
            <FormSearchField name={'regionCity'} labelKey={'Fields.label.regionCity'} classes={formClasses} load={reLoad}
              locale={locale} formActions={addressForm} required
              list={!!currentGovernate ? (cities?.map(city => city?.governateCode?.toString())?.includes(currentGovernate?.code?.toString()) ? cities?.filter(city => city?.governateCode?.toString() === currentGovernate?.code?.toString()) : cities) : cities}
              filterFunction={locale === 'ar' && ({
                filterOptions: (options, state) => options.filter(option => option['name_ar']?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا')?.includes(state?.inputValue?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا')) || option['name_en']?.toLowerCase()?.includes(state?.inputValue?.toLowerCase()))
              })} />
        }
        <FormTextField name={'street'} labelKey={'Fields.label.street'} classes={formClasses}
          formActions={addressForm} required disabled={!!isIssuer && !!address?.street} />

        <FormTextField name={'buildingNumber'} labelKey={'Fields.label.buildingNumber'} classes={formClasses}
          formActions={addressForm} required disabled={!!isIssuer && !!address?.buildingNumber} />

        <FormTextField name={'floor'} labelKey={'Fields.label.floor'} classes={formClasses}
          formActions={addressForm} />

        <FormTextField name={'room'} labelKey={'Fields.label.room'} classes={formClasses}
          formActions={addressForm} />

        <FormTextField name={'landmark'} labelKey={'Fields.label.landmark'} classes={formClasses}
          formActions={addressForm} />

        <FormTextField name={'postalCode'} labelKey={'Fields.label.postalCode'} classes={formClasses}
          formActions={addressForm}
          onChange={(event) => NumberChange(event, 'postalCode')} />

        <FormTextField name={'additionalInformation'} labelKey={'Fields.label.additionalInformation'}
          classes={formClasses}
          formActions={addressForm} row lines={3} />

        <div className={formClasses.FormSubmitRow}>
          <Button type="submit" variant='contained' size={'large'} color={'secondary'}
            onClick={addressForm.handleSubmit}
            disabled={addressForm.isSubmitting || !addressForm.isValid}
          >
            <FormattedMessage id='invoiceSteps.receiver.address.submit' />
          </Button>
          <Button variant='outlined' color='secondary'
            onClick={cancelDialog} className={'cancel'}>
            <FormattedMessage id='invoiceSteps.Cancel' />
          </Button>
        </div>
        {!!addressForm.isSubmitting && <FormLoader loading={true} />}
      </form>
    </Box>
  )
}

export default AddressForm
